<div class="Main-Container">
    <div class="spider-container">
        <div class="spider-image"></div>
        <div class="spider-txt-img"></div>
    </div>
    <div class="Dropdown-container1" [ngStyle]="{'background-color':studyname!='study Name'?'white':'','border':studyname!='study Name'?'1px solid var(--From-Std-Crosstab-Color-1, #8029B6)':'1px solid #333'}">
        <div class="Dropdown-study">
            <div class="Dropdown-study-txt" title="{{studyname}}" [ngStyle]="{'font-style':studyname!='study Name'?'normal':'italic'}">
               <span> {{studyname}}</span>
            </div>
            <div class="Dropdown-study-img">
                 <div class="Dropdown-study-img-block" [ngClass]="{ 'rotate-icon': studydropdown }" (click)="openstudyDropdown()"></div>
            </div>
        </div>
        <div class="Dropdown-popup-study"  *ngIf="studydropdown && studyNamesCount>0">
            <div class="Dropdown-popup-study-scroll">
                <div class="Studynames-container" *ngFor="let item of studtNamesArray"  (click)="studyNameclick(item)">
                    <span title="{{item}}">  {{item}} </span> 
                </div>
            </div>
        </div>
    </div>
    <div class="Dropdown-container2" [ngStyle]="{'background-color':Acrossname!='compare Across'?'white':'','z-index':studydropdown?'-99':'','opacity':studydropdown?'0.1':'','border':Acrossname!='compare Across'?'1px solid var(--From-Std-Crosstab-Color-1, #8029B6)':'1px solid #333'}">
        <div class="Dropdown-Across">
            <div class="Dropdown-Across-txt" title="{{Acrossname}}" [ngStyle]="{'font-style':Acrossname!='compare Across'?'normal':'italic'}">
             <span>{{Acrossname}}</span>
            </div>
            <div class="Dropdown-Across-img">
                 <div class="Dropdown-Across-img-block" [ngClass]="{ 'rotate-icon': Acrossdropdowncheck && AcrossDropdown.length>0 }" (click)="openacrossDropdown()"></div>
            </div>
        </div>
        <div class="Dropdown-popup-Across" *ngIf="Acrossdropdowncheck && AcrossDropdown.length>0">
          <div class="Dropdown-popup-Across-scroll">
            <div class="Across-container" *ngFor="let item of AcrossDropdown">
                 <div title="{{item.snapshotType_name}}" class="Across-container-snapshotType-txt">
                      <span title="{{item.snapshotType_name}}"> {{item.snapshotType_name}}</span>
                 </div>
                 <div class="Across-container-section-block" *ngFor="let section of item.section">
                    <div class="Across-section-container" *ngIf="section.subsection[0].subsection_name=='NA'" title="{{section.section_name}}"  (click)="AcrossNameclick(item.snapshotType_name,section.section_name,'')">
                        <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                    </div>
                    <div class="Across-subsection-container-block" *ngIf="section.subsection[0].subsection_name!='NA'">
                        <div class="Across-section-container2"  title="{{section.section_name}}">
                            <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                        </div>
                        <div class="Across-subsection-container"  title="{{section.section_name}}" *ngFor="let subsection of section.subsection"  (click)="AcrossNameclick(item.snapshotType_name,section.section_name,subsection.subsection_name)">
                            <span title="{{subsection.subsection_name}}"> {{subsection.subsection_name}}</span> 
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </div>
    </div>

    <div class="Buttons-container">   
        <div class="Config-button" (click)="configurationSnapshot()" [ngStyle]="{'display':isSuperAdmin?'flex':'none','opacity':studydropdown || Acrossdropdowncheck ?'0.1':(studyname=='study Name' && studyNamesCount>5?'0.3':''),'pointer-events':studyname=='study Name' && studyNamesCount>5 || studydropdown || Acrossdropdowncheck?'none':''}">
            <div class="Config-button-txt">Add/Configure</div>
            <div class="Config-button-img-block">
                <div class="Config-button-img" ></div>
            </div>
        </div>
        <div class="Output-button" (click)="navigateSnapshot()"  [ngStyle]="{'opacity':studydropdown || Acrossdropdowncheck ?'0.1':(studyname=='study Name' || Acrossname=='compare Across'?'0.3':''),'pointer-events':studyname=='study Name'|| Acrossname=='compare Across' || studydropdown || Acrossdropdowncheck?'none':''}">
            <div class="Output-button-txt">Explore</div>
            <div class="Output-button-img-block">
                <div class="Output-button-img" ></div>
            </div>
        </div>
    </div>
</div>
